import { Components, Theme } from '@mui/material/styles';

export const components: Components<Theme> = {
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
  },
  MuiButton: {
    styleOverrides: {
      // Every button is a pill; filled primary and success buttons also get the bright green.
      root: ({ ownerState, theme }) => {
        const isSmall = ownerState.size === 'small';
        // Outlined buttons lose 1px to the border so all variants end up the same height.
        const padding = {
          contained: isSmall ? '4px 14px' : '8px 22px',
          outlined: isSmall ? '3px 13px' : '7px 21px',
          text: isSmall ? '4px 10px' : '8px 16px',
        }[ownerState.variant ?? 'text'];
        const isGreen =
          ownerState.variant === 'contained' &&
          (ownerState.color === undefined || ownerState.color === 'primary' || ownerState.color === 'success');

        return {
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 600,
          padding,
          // A wrapped label turns the pill into a blob; `Main` sets `overflow-wrap: anywhere`, which even splits words.
          whiteSpace: 'nowrap',
          overflowWrap: 'normal',
          ...(isGreen && {
            '&:not(.Mui-disabled)': {
              backgroundColor: theme.palette.primaryButton.main,
              color: theme.palette.primaryButton.contrastText,
            },
            '&:not(.Mui-disabled):hover': {
              backgroundColor: theme.palette.primaryButton.dark,
            },
          }),
        };
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      // Buttons don't wrap their labels, so the row wraps instead of overflowing on narrow screens.
      root: ({ theme }) => ({
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        '& > :not(:first-of-type)': {
          marginLeft: 0,
        },
      }),
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        minHeight: 48,
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
  },
};
